import { render, staticRenderFns } from "./BenchmarkModal.vue?vue&type=template&id=6d5ffefa&scoped=true&"
import script from "./BenchmarkModal.vue?vue&type=script&lang=ts&"
export * from "./BenchmarkModal.vue?vue&type=script&lang=ts&"
import style0 from "./BenchmarkModal.vue?vue&type=style&index=0&id=6d5ffefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5ffefa",
  null
  
)

export default component.exports